import { registerQuery, useQuery } from 'data-fetching-client';
// @ts-expect-error untyped import
import { getInitialOptinView } from 'ui-addon-opt/state/UIOptAvailability';
const fetchOptinView = ({
  optinName
}) => {
  return getInitialOptinView(optinName);
};
export const OPTIN_AVAILABILITY_QUERY = registerQuery({
  fieldName: 'optinAvailability',
  args: ['optinName'],
  fetcher: fetchOptinView
});
export const useOptinAvailability = (optinName, options) => {
  return useQuery(OPTIN_AVAILABILITY_QUERY, {
    variables: {
      optinName
    },
    skip: options === null || options === void 0 ? void 0 : options.skip
  });
};